// Display-only status: never persist an automatic review or reviewer identity.
export function isPreviewReviewed(row) {
  if (typeof row.invoiceReviewDisplayReviewed === 'boolean') return row.invoiceReviewDisplayReviewed;
  return !!(row.attribute && row.attribute.invoice_review && row.attribute.invoice_review.reviewed);
}
